import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import * as styles from './Toast.scss';
import { ReactText } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import NetworkConnectionToast from './NetworkConnectionToast';

interface Props {
  hasNetworkIssue: boolean;
}

class ToastComponent extends React.Component<Props, object> {
  networkIssueToastId: ReactText | null = null;

  componentDidMount() {
    if (this.props.hasNetworkIssue) {
      this.networkIssue();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.hasNetworkIssue !== this.props.hasNetworkIssue) {
      if (this.props.hasNetworkIssue) {
        this.networkIssue();
      } else {
        this.networkFixed();
      }
    }
  }

  networkFixed = () => {
    if (this.networkIssueToastId) {
      toast.dismiss(this.networkIssueToastId);
      this.networkIssueToastId = null;
    }
  }

  networkIssue = () => {
    this.networkIssueToastId = toast(<NetworkConnectionToast />, {
      autoClose: false,
      closeButton: false
    });
  }

  render() {
    return (
      <ToastContainer
        className={styles.toastContainer}
        toastClassName={styles.toast}
      />
    );
  }
}

export default ToastComponent;
